import './style.css'
import * as THREE from 'three'
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js'
import { gsap, Power1 } from 'gsap'
import data from './voices.json';

// Menu
function openMenuAnimations(menuOpenTl,menuCloseTl) {
    menuCloseTl.pause();
    menuOpenTl.restart();
}

function closeMenuAnimations(menuOpenTl,menuCloseTl) {
    menuOpenTl.pause();
    menuCloseTl.restart();
}

const body = document.body,
    menuToggle = [...document.querySelectorAll('.js-menu-button')],
    menu = document.querySelector('.js-menu'),
    header = document.querySelector('.js-header');

let isActive = false;

const menuOpenTl = gsap.timeline({ paused:true });
menuOpenTl.to(menu, 0.3, { autoAlpha: 1, pointerEvents: 'all', ease: Power1.easeInOut } );

const menuCloseTl = gsap.timeline({ paused:true });
menuCloseTl.to(menu, 0.3, { autoAlpha: 0, pointerEvents: 'none', ease: Power1.easeInOut });

menuToggle.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        isActive = !isActive;

        if (isActive) {
            body.classList.add('no-scroll')
            header.classList.add('is-active')
            openMenuAnimations(menuOpenTl,menuCloseTl, btn)
        } else {
            closeMenuAnimations(menuOpenTl,menuCloseTl, btn)
            body.classList.remove('no-scroll')
            header.classList.remove('is-active')
        }
    });
});

/**
 * Base
 */
 
 // Canvas
 const canvas = document.querySelector('canvas.webgl')
 
 // Scene
 const scene = new THREE.Scene()
 scene.background = new THREE.Color(0xebe3c1)

/**
 * Sizes
 */
 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 1, 500)
let originalCamPosition = new THREE.Vector3(-5, -40, 25)
let zoomAmount = 23.5
let hitScale = 1

if(sizes.width < 800) {
    originalCamPosition = new THREE.Vector3(-5, -70, 50)
    zoomAmount = 48
    hitScale = 2

    canvas.addEventListener('click', () => {
        // hack. required for ios touch to work, no idea why
    })
}

camera.position.copy(originalCamPosition)

scene.add(camera)

// Scene shader
let uniforms

let shaderDC = new THREE.Vector3(.95, .55, .45)
let shaderAmp = new THREE.Vector3(.1, .2, .2)
let shaderFreq = new THREE.Vector3(.32, .24, .15)
let shaderPhase = new THREE.Vector3(.56,.55, .45)

const now = new Date()
let hour = parseInt(now.getHours())

switch (true) {
    case hour >= 0 && hour < 4:
        shaderDC = new THREE.Vector3(.0, .0, .09)
        shaderAmp = new THREE.Vector3(.08, .29, .18)
        shaderFreq = new THREE.Vector3(.0, .05, .13)
        shaderPhase = new THREE.Vector3(.12,.37, .73)
        break;

    case hour >= 4 && hour < 8:
        shaderDC = new THREE.Vector3(.75, .4, .1)
        shaderAmp = new THREE.Vector3(.04, .15, .2)
        shaderFreq = new THREE.Vector3(.32, .24, .15)
        shaderPhase = new THREE.Vector3(.56,.55, .45)
        break;

    case hour >= 8 && hour < 12:
        shaderDC = new THREE.Vector3(.55, .4, .52)
        shaderAmp = new THREE.Vector3(.13, .21, .0)
        shaderFreq = new THREE.Vector3(.32, .24, .15)
        shaderPhase = new THREE.Vector3(.5,.52, .46)
        break;
    
    case hour >= 12 && hour < 16:
        shaderDC = new THREE.Vector3(.39, .53, .73)
        shaderAmp = new THREE.Vector3(.27, .1, .04)
        shaderFreq = new THREE.Vector3(.43, .56, .35)
        shaderPhase = new THREE.Vector3(.5,.52, .46)
        break;
    
    case hour >= 16 && hour < 20:
        shaderDC = new THREE.Vector3(.61, .59, .79)
        shaderAmp = new THREE.Vector3(.3, .1, .0)
        shaderFreq = new THREE.Vector3(.43, .56, .35)
        shaderPhase = new THREE.Vector3(.5,.52, .46)
        break;
    
    case hour >= 20:
        shaderDC = new THREE.Vector3(.04, .08, .3)
        shaderAmp = new THREE.Vector3(.04, .23, .16)
        shaderFreq = new THREE.Vector3(.1, .14, .37)
        shaderPhase = new THREE.Vector3(.12,.37, .73)
        break;
    
    default:
        shaderDC = new THREE.Vector3(.75, .4, .1)
        shaderAmp = new THREE.Vector3(.04, .15, .2)
        shaderFreq = new THREE.Vector3(.32, .24, .15)
        shaderPhase = new THREE.Vector3(.56,.55, .45)
}

uniforms = {
    u_time: { type: 'f', value: 1.0 },
    u_resolution: { type: 'v2', value: new THREE.Vector2() },
    u_aval: { type: 'v3', value: shaderDC },
    u_bval: { type: 'v3', value: shaderAmp },
    u_cval: { type: 'v3', value: shaderFreq },
    u_dval: { type: 'v3', value: shaderPhase }
}

const skyBoxMat = new THREE.ShaderMaterial({
    uniforms,
    vertexShader: document.getElementById('vertex').textContent,
    fragmentShader: document.getElementById('fragment').textContent,
    side: THREE.BackSide
})
const skyBoxGeo = new THREE.SphereGeometry(100, 70, 35);
const skyBox = new THREE.Mesh(skyBoxGeo, skyBoxMat);
scene.add(skyBox);

const ambientLight = new THREE.AmbientLight(0xf5e5e0, .5)
scene.add(ambientLight)

const hemisphereLight = new THREE.HemisphereLight(0xfcf9f4, 0xfcf9f4, .575)
scene.add(hemisphereLight)

/**
 * Objects
 */
const material = new THREE.MeshStandardMaterial({ 
    color: new THREE.Color(0xffffff),
    roughness: .3,
    opacity: 0,
    transparent: true
})

const hitMaterial = new THREE.MeshStandardMaterial({ 
    color: new THREE.Color(0xffffff),
    opacity: 0,
    transparent: true
})

const geometry = new THREE.SphereGeometry(.65, 50, 25)
const planet1 = new THREE.Mesh(geometry, material)
planet1.name = 'planet'

const planetHitGeo = new THREE.SphereGeometry(.75, 100, 50)
const planetHit = new THREE.Mesh(planetHitGeo, hitMaterial)
planetHit.scale.set(hitScale, hitScale, hitScale)
planet1.add(planetHit)

const material2 = material.clone();
const geometry2 = new THREE.SphereGeometry(.65, 50, 25)
const planet2 = new THREE.Mesh(geometry2, material2)
planet2.name = 'planet'
planet2.add(planetHit.clone())

const material3 = material.clone();
const geometry3 = new THREE.SphereGeometry(.65, 50, 25)
const planet3 = new THREE.Mesh(geometry3, material3)
planet3.name = 'planet'
planet3.add(planetHit.clone())

const material4 = material.clone();
const geometry4 = new THREE.SphereGeometry(.65, 50, 25)
const planet4 = new THREE.Mesh(geometry4, material4)
planet4.name = 'planet'
planet4.add(planetHit.clone())

const material5 = material.clone();
const geometry5 = new THREE.SphereGeometry(.65, 50, 25)
const planet5 = new THREE.Mesh(geometry5, material5)
planet5.name = 'planet'
planet5.add(planetHit.clone())

const planets = new THREE.Group()
planets.name = 'planets'

planets.add(planet1)
planets.add(planet2)
planets.add(planet3)
planets.add(planet4)
planets.add(planet5)

planets.renderOrder = 1

scene.add(planets)

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    originalCamPosition = new THREE.Vector3(-5, -40, 25)
    zoomAmount = 23.5
    let hitScale = 1

    if(sizes.width < 800) {
        originalCamPosition = new THREE.Vector3(-5, -70, 55)
        zoomAmount = 51
        hitScale = 2
    }

    if(!watchPlanet) {
        camera.position.copy(originalCamPosition)

        planets.children.forEach((planet) => {
            const planetHit = planet.children[0]
    
            if(planetHit) {
                planetHit.scale.set(hitScale, hitScale, hitScale)
            }
        })
    }

    uniforms.u_resolution.value.x = renderer.domElement.width;
    uniforms.u_resolution.value.y = renderer.domElement.height;
})

function getRandomIntInclusive(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min + 1) + min)
}

let ambientSound;
const loadingMessage = document.querySelector('.loading-message')

function loadAudio() {
    const listener = new THREE.AudioListener()
    camera.add(listener)

    document.body.style.cursor = 'wait'

    ambientSound = new THREE.Audio(listener)

    const ctx = new AudioContext()
    let audio

    fetch('./sounds/ambient.mp3')
        .then(data => data.arrayBuffer())
        .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
        .then(decodedAudio => {
            audio = decodedAudio
        })
        .then(() => {
            ambientSound.setBuffer(audio)
            ambientSound.setLoop(true)
            ambientSound.setVolume(.7)
            ambientSound.play()
        })
    
    let randomNumbers = []

    // Get random number for each planet
    while(randomNumbers.length < planets.children.length) {
        let rand = getRandomIntInclusive(0, 50)
        if(randomNumbers.indexOf(rand) === -1) randomNumbers.push(rand)
    }

    let counter = 0
    
    // Loop over planets, assign sound and push to currentSounds
    planets.children.forEach((planet, i) => {
        const sound = new THREE.PositionalAudio(listener)
        const voice = data.voices[randomNumbers[i]]
        const filename = `./sounds/${voice.file}`
            
        planet.userData.transcript = voice.transcript

        const ctx = new AudioContext()
        let audio

        fetch(filename)
            .then(data => data.arrayBuffer())
            .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
            .then(decodedAudio => {
                audio = decodedAudio
            })
            .then(() => {
                sound.setBuffer(audio)
                sound.setLoop(true)
                sound.setVolume(.5)
                sound.setRefDistance(.5)
                planet.add(sound)
                counter++

                if(counter === 5) {
                    loader.classList.add('hidden')

                    loadingMessage.classList.add('hide')
            
                    document.documentElement.classList.add('no-scroll')
            
                    planets.children.forEach((planet, i) => {
                        const delay = i * .5;
                        
                        gsap.to(planet.material, {
                            opacity: 1,
                            duration: .95,
                            delay: .5 + delay
                        })
                    })
            
                    gsap.to(torusMesh.material, {
                        opacity: 1,
                        duration: .65,
                        delay: 2.95
                    })
            
                    gsap.to(footer, {
                        opacity: 1,
                        duration: .25,
                        delay: 3.25,
                        onComplete: () => {
                            footer.classList.add('loaded')
                            zoomOut = false
                            document.body.style.cursor = 'auto'
                        }
                    })
                }
            })
    })
}

function loadNewSounds() {
    const listener = new THREE.AudioListener()
    camera.add(listener)
    
    document.body.style.cursor = 'wait'

    loadingMessage.classList.remove('hide')

    gsap.to(torusMesh.material, {
        opacity: 0,
        duration: .25,
        onComplete: () => {
            zoomOut = true
        }
    })
    
    planets.children.forEach((planet, i) => {
        const delay = i * .25;

        gsap.to(planet.material, {
            opacity: 0,
            duration: .5,
            delay: .25 + delay
        })

        if(planet.children[1]) {
            planet.remove(planet.children[1])
        }
    })

    let newRandomNumbers = []

    while(newRandomNumbers.length < planets.children.length) {
        let rand = getRandomIntInclusive(0, 50)
        if(newRandomNumbers.indexOf(rand) === -1) newRandomNumbers.push(rand)
    }

    let counter = 0

    planets.children.forEach((planet, i) => {
        const sound = new THREE.PositionalAudio(listener)
        const voice = data.voices[newRandomNumbers[i]]
        const filename = `./sounds/${voice.file}`

        planet.userData.transcript = voice.transcript

        const ctx = new AudioContext()
        let audio

        fetch(filename)
            .then(data => data.arrayBuffer())
            .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
            .then(decodedAudio => {
                audio = decodedAudio
            })
            .then(() => {
                sound.setBuffer(audio)
                sound.setLoop(true)
                sound.setVolume(.5)
                sound.setRefDistance(.5)
                planet.add(sound)
                counter++
                
                if(counter === 5) {
                    setTimeout(() => {
                        loadingMessage.classList.add('hide')
                    
                        planets.children.forEach((planet, i) => {
                            const delay = i * .5;
                            
                            gsap.to(planet.material, {
                                opacity: 1,
                                duration: .95,
                                delay: .5 + delay
                            })
                        })
                
                        gsap.to(torusMesh.material, {
                            opacity: 1,
                            duration: .65,
                            delay: 2.95,
                            onComplete: () => {
                                zoomOut = false
                                document.body.style.cursor = 'auto'
                            }
                        })
                    }, 1500)
                }
            })
    })

}

const loader = document.getElementById('loader')
const play = document.getElementById('play')
const footer = document.querySelector('.footer')
const reload = document.getElementById('reload')

reload.addEventListener('click', () => {
    loadNewSounds()
})

let zoomOut = false

loader.classList.add('loaded')

play.addEventListener('click', () => {
    zoomOut = true
    
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
    
    loader.classList.add('hide')

    setTimeout(() => {
        loader.classList.add('fade')
    }, 500)

    loadAudio()
})

const curve = new THREE.EllipseCurve(
    0,  0,              // ax, aY
	17, 12,             // xRadius, yRadius
	0,  2 * Math.PI,    // aStartAngle, aEndAngle
	false,              // aClockwise
	0                   // aRotation
);

const points = curve.getPoints(50);

const curveGeometry = new THREE.BufferGeometry().setFromPoints(points)
const curveMaterial = new THREE.LineBasicMaterial({ 
    color: 0xffffff,
    opacity: 0,
    transparent: true
})

// Create the final object to add to the scene
const ellipse = new THREE.Line(curveGeometry, curveMaterial)
scene.add(ellipse)

const torus = new THREE.TorusGeometry(17, .033, 50, 150)
const torusMaterial = new THREE.MeshStandardMaterial({ 
    color: 0xffffff,
    roughness: .3,
    opacity: 0,
    transparent: true
});
const torusMesh = new THREE.Mesh(torus, torusMaterial)
// 12 / 17 to match ellipse size
torusMesh.scale.y = .7058823
torusMesh.renderOrder = 2

scene.add(torusMesh)

camera.lookAt(ellipse.position)

// Controls
const controls = new TrackballControls(camera, canvas)
controls.noRotate = true
controls.noZoom = true
controls.noPan = true

var mouse = new THREE.Vector2()

var raycaster = new THREE.Raycaster()
let watchPlanet = false
let clickedObject
let clickedAudio
let planetTalkTl

const transcriptsEl = document.getElementById('transcripts')
const transcriptsText = transcriptsEl.querySelector('.transcripts__text')
const transcriptsContent = transcriptsEl.querySelector('#transcriptsContent')

function onMouseClick() {
    raycaster.setFromCamera(mouse, camera)
    raycaster.params.Line.threshold = 0

    const isIntersected = raycaster.intersectObject(scene, true)

    if(isIntersected.length > 0 && isIntersected[0].object.parent.name === 'planet' && !zoomOut) {
        clickedObject = isIntersected[0].object.parent
        clickedAudio = clickedObject.children[1]

        isIntersected[0].object.scale.set(0, 0, 0)

        if(clickedAudio.isPlaying === false) {
            clickedAudio.play()
        }

        transcriptsText.innerHTML = clickedObject.userData.transcript

        watchPlanet = true

        gsap.to(footer, {
            opacity: 0,
            duration: .25,
            onComplete: () => {
                footer.classList.remove('loaded')
            }
        })

        gsap.to(transcripts, {
            opacity: 1,
            duration: .25,
            delay: .25,
            onComplete: () => {
                transcripts.classList.add('loaded')
            }
        })

        planetTalkTl = gsap.timeline({repeat: -1, yoyo: true});

        planetTalkTl.to(clickedObject.scale, {
            x: 1.15,
            y: 1.15,
            z: 1.15,
            duration: .75
        })

        planetTalkTl.to(clickedObject.material.emissive, {
            r: .095,
            g: .095,
            b: .075,
            duration: .75
        })
    } else if(watchPlanet) {
        watchPlanet = false

        planets.children.forEach((planet) => {
            const planetHit = planet.children[0]
            const planetAudio = planet.children[1]

            if(planetHit) {
                planetHit.scale.set(hitScale, hitScale, hitScale)
            }
    
            if(planetAudio && planetAudio.isPlaying) {
                planetAudio.stop()
            }
        })

        ambientSound.setVolume(.7)

        gsap.to(controls.target, {
            x: ellipse.position.x,
            y: ellipse.position.y,
            z: ellipse.position.z,
            duration: 1.25,
            onUpdate: () => {
                controls.update()
                ellipse.updateMatrixWorld()
            }
        })

        gsap.to(camera.position, {
            x: originalCamPosition.x,
            y: originalCamPosition.y,
            z: originalCamPosition.z,
            duration: 1.25,
            onStart: () => {
                zoomOut = true
            },
            onUpdate: () => {
                camera.lookAt(ellipse.position)
            },
            onComplete: () => {
                clickedObject = null
                zoomOut = false
            }
        })

        gsap.to(transcripts, {
            opacity: 0,
            duration: .25,
            onComplete: () => {
                transcripts.classList.remove('loaded')
            }
        })

        gsap.to(footer, {
            opacity: 1,
            duration: .25,
            delay: .25,
            onComplete: () => {
                footer.classList.add('loaded')
            }
        })

        // Kill previous animation
        if(planetTalkTl) {
            planetTalkTl.pause(0)
            planetTalkTl.seek(0)
            planetTalkTl.kill()
        }

        setTimeout(() => {
            transcriptsText.innerHTML = ''
        }, 150)
    }
}

window.addEventListener('click', (event) => {
    if(event.target.matches(['.transcripts__content', '.transcripts__content p'])) {
        return
    }

    if(event.target.matches(['#closeTranscript', '#closeTranscript svg', '#closeTranscript path', '#closeTranscript g'])) {
        transcriptsContent.classList.remove('show')
        return
    }

    if(event.target.matches('#loadTranscript')) {
        transcriptsContent.classList.add('show')
        return
    }

    transcriptsContent.classList.remove('show')

    onMouseClick()
}, false)

var hoverRaycaster = new THREE.Raycaster()
let hoverPlanet = false
let hoveredObject

function onMouseMove(event) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1
    mouse.y = - (event.clientY / window.innerHeight) * 2 + 1

    hoverRaycaster.setFromCamera(mouse, camera)
    hoverRaycaster.params.Line.threshold = 0

    var isIntersected = hoverRaycaster.intersectObject(scene, true)

    if(isIntersected.length > 0 && isIntersected[0].object.parent.name === 'planet' && isIntersected[0].object) {
        hoveredObject = isIntersected[0].object.parent;

        hoverPlanet = true
        document.body.style.cursor = 'pointer'

    } else if(hoverPlanet) {
        hoverPlanet = false
        document.body.style.cursor = 'auto'

        if(watchPlanet && planetTalkTl) {
            planetTalkTl.play()
        }

        if(hoveredObject && hoveredObject !== clickedObject) {
            gsap.to(hoveredObject.scale, {
                x: 1,
                y: 1,
                z: 1,
                duration: .75
            })

            gsap.to(hoveredObject.material.emissive, {
                r: 0,
                g: 0,
                b: 0,
                duration: .75
            })
        }
    }
}

window.addEventListener('mousemove', onMouseMove, false)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

uniforms.u_resolution.value.x = renderer.domElement.width
uniforms.u_resolution.value.y = renderer.domElement.height

/**
 * Animate
 */
const clock = new THREE.Clock()

// Starting points
let t = 0
let t2 = .2
let t3 = .4
let t4 = .6
let t5 = .8

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Increment position speed
    t += 0.00009
    t2 += 0.00009
    t3 += 0.00009
    t4 += 0.00009
    t5 += 0.00009

    var pos = curve.getPoint(t)
    var pos2 = curve.getPoint(t2)
    var pos3 = curve.getPoint(t3)
    var pos4 = curve.getPoint(t4)
    var pos5 = curve.getPoint(t5)

    planet1.position.set(pos.x, pos.y, pos.z)
    planet2.position.set(pos2.x, pos2.y, pos2.z)
    planet3.position.set(pos3.x, pos3.y, pos3.z)
    planet4.position.set(pos4.x, pos4.y, pos4.z)
    planet5.position.set(pos5.x, pos5.y, pos5.z)

    // Update controls
    controls.update()
    
    if(watchPlanet) {
        // Wait for initial zoom in to complete
        gsap.to(controls.target, {
            x: clickedObject.position.x,
            y: clickedObject.position.y,
            z: clickedObject.position.z,
            onUpdate: () => {
                controls.update()
                clickedObject.updateMatrixWorld()
            }
        })

        gsap.to(camera.position, {
            x: clickedObject.position.x,
            y: clickedObject.position.y - Math.PI,
            z: originalCamPosition.z - zoomAmount,
            onUpdate: () => {
                camera.lookAt(clickedObject.position)
            }
        })

        planets.children.forEach((planet) => {
            const planetAudio = planet.children[1]
            if(planetAudio) {
                planetAudio.setVolume(.5)
                planetAudio.setRefDistance(.25)
            }
        })

        clickedAudio.setVolume(1.7)
        clickedAudio.setRefDistance(1)

        planetTalkTl.play()

        ambientSound.setVolume(.25)
    }

    if(hoverPlanet && hoveredObject !== clickedObject) {
        gsap.to(hoveredObject.scale, {
            x: 1.1,
            y: 1.1,
            z: 1.1,
            duration: .75
        })

        gsap.to(hoveredObject.material.emissive, {
            r: .095,
            g: .095,
            b: .075,
            duration: .75
        })
    }

    uniforms.u_time.value = elapsedTime * 1.25

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()